import { render, staticRenderFns } from "./productImageList.vue?vue&type=template&id=a95e6d8c&"
import script from "./productImageList.vue?vue&type=script&lang=js&"
export * from "./productImageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports